import { render } from "./EntitySelectorCarreta.vue?vue&type=template&id=86416ce6"
import script from "./EntitySelectorCarreta.vue?vue&type=script&lang=ts"
export * from "./EntitySelectorCarreta.vue?vue&type=script&lang=ts"
script.render = render

export default script